import { BCDataGrid } from '@bimser/components';
import { Anchor, Workbook } from 'exceljs';
import saveAs from 'file-saver';
import DataGrid2 from '../..';

export async function onExporting(
	this: DataGrid2,
	e: BCDataGrid.Entities.DataGridTypes.ExportingEvent
) {
	const workbook = new Workbook();
	const worksheet = workbook.addWorksheet('Main sheet');

	await BCDataGrid.Components.exportDataGrid({
		component: e.component,
		worksheet: worksheet,
		autoFilterEnabled: true,
		customizeCell: ({ gridCell, excelCell }) => {
			if (gridCell.rowType === 'data') {
				const bcColumn = this.__getBCColumn(gridCell.column.name);

				switch (bcColumn.editType) {
					case 'fileSelect': {
						bindImageColumn({ gridCell, excelCell, workbook, worksheet, bcColumn });
						break;
					}
					default: {
						break;
					}
				}
			}
		}
	});

	const buffer = await workbook.xlsx.writeBuffer();

	saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${this.name}.xlsx`);
}

function bindImageColumn({ gridCell, excelCell, workbook, worksheet, bcColumn }) {
	if (gridCell.value || bcColumn.defaultImage) {
		excelCell.value = undefined;

		const image = workbook.addImage({
			base64: gridCell.value || bcColumn.defaultImage,
			extension: 'png'
		});

		worksheet.getRow(excelCell.row).height = 100;
		worksheet.addImage(image, {
			tl: { col: excelCell.col - 1, row: excelCell.row - 1 } as Anchor,
			br: { col: excelCell.col, row: excelCell.row } as Anchor
		});
	}
}
